import NotificationTune from "../assets/notification.mp3"
export const playSound = () => {
    const audio = new Audio(NotificationTune);
    audio.play();
  };